/*
 * @Author: Teemo Ding
 * @Date: 2022-03-01 15:39:30
 * @LastEditTime: 2022-06-10 09:03:50
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCommunication/config.tsx
 */
import React from 'react';
import { templateCategoryList } from 'src/pages/Settings/Communication/CommunicationTemplateDetail/config';
import { CommunicationChannelTypeMp } from 'src/types/common/communication';
import StatusTag, { EnabledChannelsStatus } from './Components/StatusTag';
import css from './css.module.less';

export const communicationColumns = (deleteFun, disableDelete, { getI18n }) => [
  {
    title: getI18n(
      'salesChannelCommunication.communicationCategory.communicationChannel',
    ),
    dataIndex: 'channelType',
    key: 'channelType',
    default: true,
    optional: false,
    className: css.columnClass,
    minWidth: 288,
  },
  {
    title: getI18n(
      'salesChannelCommunication.communicationCategory.communicaitonGateway',
    ),
    dataIndex: 'name',
    key: 'name',
    default: true,
    optional: false,
    className: css.columnClass,
    minWidth: 288,
    render: (_, record) =>
      (record.gateways || []).map((item, index) => (
        <div key={index} className={css.communicaitonItem}>
          {item?.name}
        </div>
      )),
  },
  {
    title: getI18n(
      'salesChannelCommunication.communicationCategory.communicaitonGatewayProvider',
    ),
    dataIndex: 'salesChannelPaymentMethods',
    key: 'gatewayProvider',
    default: true,
    optional: false,
    className: css.columnClass,
    minWidth: 224,
    render: (_, record) =>
      (record.gateways || []).map((item, index) => (
        <div key={index} className={css.communicaitonItem}>
          {item?.gatewayProvider}
        </div>
      )),
  },
  disableDelete
    ? {}
    : {
        title: getI18n(
          'general.advancedFilters.commonStoreProductsWithTable.actions',
        ),
        dataIndex: 'action',
        key: 'action',
        default: true,
        optional: false,
        className: css.columnClass,
        width: 128,
        align: 'center',
        render: (_, record) =>
          (record.gateways || []).map((item, index) => (
            <div key={index} className={css.action}>
              <span className={css.danger} onClick={() => deleteFun(item.uuid)}>
                {getI18n('general.remove')}
              </span>
            </div>
          )),
      },
];

export const priorityColumns = ({ getI18n }) => [
  {
    title: getI18n('salesChannelCommunication.communicationCategory.priority'),
    dataIndex: 'index',
    key: 'index',
    default: true,
    optional: false,
    className: css.columnClass,
    minWidth: 74,
    render: (_, record, index) => index + 1,
  },
  {
    title: getI18n(
      'salesChannelCommunication.communicationCategory.communicationChannel',
    ),
    dataIndex: 'channel',
    key: 'channel',
    default: true,
    optional: false,
    className: css.columnClass,
    minWidth: 968,
    render: (_, record) => record,
  },
];
export const communicationTemplatesColumns = (
  categoryGroup,
  priorities,
  editFun,
  disableEdit: boolean,
  { getI18n },
) => [
  {
    title: getI18n(
      'salesChannelCommunication.communicationCategory.communicationCategory',
    ),
    dataIndex: 'category',
    key: 'category',
    default: true,
    optional: false,
    className: css.columnClass,
    minWidth: 320,
    render: (text) =>
      (
        (
          templateCategoryList.filter((k) => k.key === categoryGroup)[0] || {}
        ).children.filter((o) => o.value === text)[0] || {}
      ).label,
  },
  ...((priorities || []).length
    ? priorities.map((item) => ({
        title:
          item == CommunicationChannelTypeMp.WechatMP
            ? getI18n(
                'salesChannelCommunication.communicationCategory.miniProgramNotification',
              )
            : `${item} ${getI18n(
                'salesChannelCommunication.communicationCategory.notification',
              )}`,
        dataIndex: item,
        key: item,
        default: true,
        optional: false,
        className: css.columnClass,
        minWidth: 160,
        render: (_, record) => (
          <div className={css.noCommunication}>
            <StatusTag
              status={
                record.enabledChannels.includes(item)
                  ? EnabledChannelsStatus.On
                  : EnabledChannelsStatus.Off
              }
            />
          </div>
        ),
      }))
    : [
        {
          title: '',
          dataIndex: 'channel',
          key: 'channel',
          default: true,
          optional: false,
          className: css.columnClass,
          minWidth: 640,
          render: () => (
            <div className={css.noCommunication}>
              {getI18n(
                'salesChannelCommunication.communicationCategory.selectcommunicationgatewayfirst',
              )}
            </div>
          ),
        },
      ]),

  disableEdit
    ? {}
    : {
        title: getI18n(
          'general.advancedFilters.commonStoreProductsWithTable.actions',
        ),
        dataIndex: 'action',
        key: 'action',
        default: true,
        optional: false,
        className: css.columnClass,
        width: 128,
        align: 'center',
        render: (_, record) => (
          <div className={css.action}>
            <span
              className={css.primary}
              onClick={() => editFun(record.category)}>
              {getI18n('general.edit')}
            </span>
          </div>
        ),
      },
];
